import { withApollo } from "react-apollo";

import Pagination from "../../Common/Pagination";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
import { getListOfTransactionsQuery } from "../../../services/graphql/queries/auto-numbering";
import { PAGINATION_OFFSET_VALUE } from "../../../constants/app-constants";
import { redirectTo } from "../../../util/redirect";
import React from "react";

import AutoNumeringFilter from "./autoNumberingFilter";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import NotAccessible from "../../Common/NotAccessible";

import view from "../../../static/images/svg/view.svg";
class AutoNumberingList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilter: false,
      pageOfItems: [],
      currentPage: 1,
      offset: PAGINATION_OFFSET_VALUE,
      loading: false,
      errors: [],
      error: "",
      accessSpecifier: {},
    };

    this.filterAction = this.filterAction.bind(this);
    this.onFilterData = this.onFilterData.bind(this);
  }

  onViewUser(id) {
    // redirectTo("/auto-numbering-profile?id=" + id);
    this.props.history.push("/auto-numbering-profile?id=" + id);
  }

  onFilterData(data) {
    console.log("filter data", data);
    this.setState({ pageOfItems: data });
  }

  filterAction() {
    this.setState((prevState) => {
      return {
        showFilter: !prevState.showFilter,
      };
    });
  }

  onChangePage(currentPage) {
    // update state with new page of items
    this.setState({
      currentPage: currentPage,
    });
    this.setState({ loading: true });

    this.props.client
      .query({
        query: getListOfTransactionsQuery,
        variables: { offset: this.state.offset, pageNo: currentPage },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const user = result.data.getListofTransaction;

        this.initialState = {
          pageOfItems: user,
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.getListofTransaction);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  getListOfTransactions() {
    this.props.client
      .query({
        query: getListOfTransactionsQuery,
        variables: {
          offset: this.state.offset,
          pageNo: this.state.currentPage,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        const user = result.data.getListofTransaction;

        this.initialState = {
          pageOfItems: user,
        };

        this.setState({ ...this.initialState });
        this.setState({ loading: false, error: "" });
        console.log("~~~result: ", result.data.getListofTransaction);
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, error: error.message });
      });
  }

  componentDidMount() {
    this.setState({ loading: true });

    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: 6,
        },
        fetchPolicy: "network-only",
      })
      .then((result) => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        this.setState({
          accessSpecifier: response[171],
        });
        this.getListOfTransactions();
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error.message,
        });
      });
  }

  render() {
    const { loading, error, accessSpecifier } = this.state;
    const users = this.state.pageOfItems;
    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div>{error}</div>;
    }
    return (
      <>
        {accessSpecifier && accessSpecifier.viewP ? (
          <div>
            <div className="row align-items-center no-gutters">
              <div className="col-md-11">
                <h1 className="heading m-b-0">Auto Numbering List View</h1>
              </div>
              <div className="col-md-1 text-right">
                <button
                  className="btn btn-primary filter-btn"
                  onClick={this.filterAction}
                >
                  Filter
                </button>
              </div>
              <AutoNumeringFilter
                showFilter={this.state.showFilter}
                listData={this.onFilterData}
                displayFilter={this.filterAction}
              />
            </div>
            <table className="table table-style-1">
              <thead>
                <tr>
                  <th>TRANSACTION TYPE</th>
                  <th>DESCRIPTION</th>
                  <th>ACTION(s)</th>
                </tr>
              </thead>
              <tbody>
                {users.length
                  ? users.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.shortDescription}</td>
                          <td>{data.longDescription}</td>
                          <td>
                            <a
                              href="#"
                              class="link-primary"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="view"
                              onClick={this.onViewUser.bind(this, data.Id)}
                            >
                              <img src={view} />
                            </a>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </tbody>
            </table>
            {!users.length && error ? <div>{error}</div> : null}
            {!users.length && loading ? <div>Fetching...</div> : null}
            {!users.length && !error && !loading ? (
              <div style={{ textAlign: "center" }}>No Data</div>
            ) : null}
            <Pagination
              loading={loading}
              items={users}
              pageSize={this.state.offset}
              initialPage={this.state.currentPage}
              onChangePage={this.onChangePage.bind(this)}
            />
          </div>
        ) : (
          <NotAccessible />
        )}
      </>
    );
  }
}
export default withRouter(withApollo(AutoNumberingList));
